"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
function Spy(_a) {
    var mutators = _a.form.mutators, values = _a.values;
    var prevValues = React.useRef(values);
    React.useLayoutEffect(function () {
        mutators.resetSubmitErrors({
            current: values,
            prev: prevValues.current
        });
        prevValues.current = values;
    });
    return null;
}
function SubmitErrorsSpy() {
    return React.createElement(react_final_form_1.FormSpy, { subscription: { values: true }, render: Spy });
}
exports["default"] = SubmitErrorsSpy;
